<template>
  <vs-row>
    <vs-col vs-lg="12" vs-sm="12" class="p-2">
      <UserInfo
        :teacherPersonalDetails="teacherPersonalDetails"
        @setAfterUpdate="setAfterUpdate"
      />
    </vs-col>
    <!-- <vs-col vs-lg="3" vs-sm="12" class="p-2">
      <vs-card style="border: 1px solid #00cfdd" class="content_mb_0 mb-0">
        <div class="flex flex-wrap justify-between items-center">
          <p style="font-size: 18px">Current Plan</p>
          <p class="plan_badge">Basic</p>
        </div>
        <p class="text-muted">July 22, 2022</p>
        <p class="text-muted">1 User</p>
        <vs-button class="w-full mt-4">Upgrade Plan</vs-button>
      </vs-card>
    </vs-col> -->
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>User Timeline</h4>
        </div>
        <div style="max-height: 300px; overflow-y: auto" class="vertical_scrollbar">
          <activity-timeline
            :staff_id="teacher_id"
            :new_activity="new_activity"
          />
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <vs-card class="content_mb_0 mb-0 h-full">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>Permissions</h4>
          <vs-tooltip text="View All" color="primary">
            <vs-button type="border" color="primary" icon-pack="feather" icon="icon-eye" />
          </vs-tooltip>
        </div>
        <div>
          <h6 class="mb-2">Schedule</h6>
          <div
            style="max-height: 300px; overflow-y: auto"
            class="vertical_scrollbar"
          >
            <div
              class="user_schedule_holder"
              v-for="(eachScheduleData, index) in schedules"
              :key="index"
            >
              {{ eachScheduleData.title }}
              <vs-checkbox v-model="eachScheduleData.active" />
            </div>
          </div>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import activityTimeline from '@/views/pages/users/components/ActivityTimeline.vue'

import UserInfo from '@/views/pages/v1/user_profile/components/account/user_info.vue'

export default {
  props: {
    teacherPersonalDetails: {
      default: {}
    },
    new_activity: {
      default: {}
    },
    teacher_id: {
      default: null
    }
  },
  data () {
    return {
      schedules: [
        {
          id: 1,
          title: 'Student Course Schedule View',
          active: true
        },
        {
          id: 2,
          title: 'Teacher Course Schedule View',
          active: true
        },
        {
          id: 3,
          title: 'Room view',
          active: true
        },
        {
          id: 4,
          title: 'Cancel Schedule',
          active: true
        },
        {
          id: 5,
          title: 'Reschedule Session',
          active: true
        }
      ]
    }
  },
  components: {
    UserInfo,
    activityTimeline
  },
  methods: {
    async setAfterUpdate (data) {
      console.log("from index", data)
      this.$emit('setAfterUpdate', data)
    }
  }
}
</script>